import { render, staticRenderFns } from "./processInfo.vue?vue&type=template&id=06811436&"
import script from "./processInfo.vue?vue&type=script&lang=js&"
export * from "./processInfo.vue?vue&type=script&lang=js&"
import style0 from "./processInfo.vue?vue&type=style&index=0&id=06811436&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports